module.exports = __webpack_public_path__ + "media/assets/images/logos/leanbit_logo3d-6a74cea49d87ef9b40822411ce35580c.png";